import React from "react";

const ClientListPageSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Table */}
      <div className="bg-white divide-y divide-ink-100 rounded-lg shadow">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex items-center px-4 py-4 gap-4">
            <div className="size-10 bg-cream-300 rounded-full"></div>
            <div className="flex-1">
              <div className="h-4 bg-cream-300 rounded w-32 mb-2"></div>
              <div className="h-3 bg-cream-300 rounded w-48 mb-1"></div>
              <div className="h-3 bg-cream-300 rounded w-40"></div>
            </div>
            <div className="h-4 bg-cream-300 rounded w-24"></div>
            <div className="h-4 bg-cream-300 rounded w-24"></div>
          </div>
        ))}
      </div>
      {/* Pagination */}
      <div className="flex justify-end mt-4 gap-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-6 w-6 bg-cream-300 rounded-full"></div>
        ))}
      </div>
    </div>
  );
};

export default ClientListPageSkeleton;
